<template>
    <div id="edit">
        <div class="contents">
            <div class="ui active inverted dimmer" v-if="is_processing || !is_initialized">
                <div class="ui text loader">
                    {{ $t('ui.general.initializing') }}
                </div>
            </div>
            <div class="ui form" v-else>
                <h2 class="ui header">
                    {{ $t('ui.page_titles.edit_asset') }}
                </h2>
                <div class="eight wide field" :class="{'error': if_error('category')}">
                    <label>
                        {{ $t('models.attributes.assets.category') }}
                    </label>
                    <select v-model="asset.category">
                        <option v-for="category in $store.state.provider.assets_module.categories" :value="category">{{category}}</option>
                    </select>
                    <div v-if="if_error('category')" class="ui pointing red basic label">
                        {{ error_message("category") }}
                    </div>
                </div>
                <div class="eight wide field" :class="{'error': if_error('number')}">
                    <label>
                        {{ $t('models.attributes.assets.number') }}
                    </label>
                    <input type="text" v-model="asset.number" :placeholder="$t('models.attributes.assets.number')">
                    <div v-if="if_error('number')" class="ui pointing red basic label">
                        {{ error_message("number") }}
                    </div>
                </div>
                <div class="eight wide field" :class="{'error': if_error('note')}">
                    <label>
                        {{ $t('models.attributes.assets.note') }}
                    </label>
                    <textarea v-model="asset.note" rows="8" cols="80"></textarea>
                    <div v-if="if_error('note')" class="ui pointing red basic label">
                        {{ error_message("note") }}
                    </div>
                </div>
                <div class="ui basic positive button" @click="update">
                    {{ $t('ui.general.submit') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditAsset",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            asset: {},
            errors: [],
            error_columns: []
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "edit_asset") {
                this.init()
            }
        },
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.asset = {}
                this.errors = []
                this.error_columns = []
                resolve()
            })
            await this.fetch_asset()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_asset() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_asset).parse(
                {
                    "asset_identity": this.$route.params.id,
                },
                ""
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.asset = response.data.asset
                    this.$noty.success(
                        this.$t('ui.notifications.success.fetch__name', {
                            name: this.$t('models.assets'),
                        })
                    )
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.assets'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        },
        update() {
            this.is_processing = true
            this.errors = []
            this.error_columns = []
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_asset_update).parse(
                {
                    "asset_identity": this.asset.identity,
                },
                ""
            )

            axios.post(
                    url,
                    this.asset,
                    {headers: { Authorization: localStorage.getItem("authentication_token") }}
                )
                .then(response => {
                    if (response.data.status == "success") {
                        this.$router.push("/provider/assets/index/" + response.data.asset.category)
                    } else {
                        this.errors = response.data.errors
                        this.error_columns = Object.keys(response.data.errors)
                    }
                })
                .catch(error => {
                })
            this.is_processing = false
        },
        if_error(column_name) {
            if (this.error_columns.indexOf(column_name) != -1) {
                return true
            } else {
                return false
            }
        },
        error_message(column_name) {
            return _.join(this.errors[column_name], ', ')
        }
    },
    components: {
    }
}
</script>

<style scoped>
</style>
